import { withCurrentParams } from '../utils';
import { BROADCAST_PERSIST_ID } from '../Types';

function persistAttendeeId(attendeeId) {
  return withCurrentParams((dispatch, { broadcastId }) => {
    const { sessionStorage } = window;
    sessionStorage.setItem(
      'BROADCAST-ATTENDEE-KEY',
      JSON.stringify({
        broadcastId,
        attendeeId
      })
    );
    const action = {
      type: BROADCAST_PERSIST_ID,
      payload: {
        broadcastId
      }
    };
    dispatch(action);
  });
}

export default persistAttendeeId;
